import AScene from "./AScene.js"

export default class AImage extends Phaser.GameObjects.Image
{
     /**
     * @param {AScene} scene 
     */
    constructor(scene, x, y, texture, frame)
    {
        super(scene, x, y, texture, frame);
        this.tintData = 0xff0000;
    }

    get tint()
    {
        return this.tintData;
    }

    set tint(value)
    {
        this.tintData = value;
        super.tint = value;
    }

    setSize(width, height)
    {
        this.width = width;
        this.height = height;
        this.displayWidth = width;
        this.displayHeight = height;
    }

    setMaxSize(width, height) 
    {
        let scaleBy = (this.width > this.height) ? width / this.width : height / this.height;
        this.setSize(this.width * scaleBy, this.height * scaleBy);
     };
}